/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharecopyshort2Inputs */

const en_sharecopyshort2 = /** @type {(inputs: Sharecopyshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_sharecopyshort2 = /** @type {(inputs: Sharecopyshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Sharecopyshort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharecopyshort2 = /** @type {((inputs?: Sharecopyshort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharecopyshort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharecopyshort2(inputs)
	return de_sharecopyshort2(inputs)
});
export { sharecopyshort2 as "shareCopyShort" }